import React from 'react';
import { CrossArea } from './components/shapes/CrossArea';

const RightPanel = ({ selectedObject, onPropertyChange, selectedCrossColorId, onSelectedCrossColorIdChange }) => {
    if (!selectedObject) {
        return (
            <div style={styles.container}>
                <h3>Properties</h3>
                <p>No object selected</p>
            </div>
        );
    }

    const { color, fillColor, fillType, spacing, angle, segmentLength, contourStitchType, cols, rows, crossSize } = selectedObject;

    const handleColorChange = (e) => {
        onPropertyChange('color', e.target.value);
    };

    const handleContourStitchTypeChange = (e) => {
        onPropertyChange('contourStitchType', e.target.value);
    };

    const handleFillColorChange = (e) => {
        onPropertyChange('fillColor', e.target.value);
    };

    const handleFillTypeChange = (e) => {
        onPropertyChange('type', e.target.value);
    };

    const handleSpacingChange = (e) => {
        onPropertyChange('spacing', parseFloat(e.target.value));
    };

    const handleAngleChange = (e) => {
        onPropertyChange('angle', parseFloat(e.target.value));
    };

    const handleSegmentChange = (e) => {
        onPropertyChange('segmentLength', parseFloat(e.target.value));
    };


    return (
        <div style={styles.container}>
            <h3 style={styles.title}>Properties</h3>

            <div style={styles.section}>
                <h4 style={styles.sectionTitle}>Style</h4>
                <div style={styles.row}>
                    <label style={styles.label}>Stroke:</label>
                    <input
                        type="color"
                        value={color || '#000000'}
                        onChange={handleColorChange}
                        style={styles.colorInput}
                    />
                </div>
                <div style={styles.row}>
                    <label style={styles.label}>Contour Stitch:</label>
                    <select
                        value={contourStitchType || 'simple'}
                        onChange={handleContourStitchTypeChange}
                        style={styles.select}
                    >
                        <option value="simple">Simple</option>
                        <option value="double">Double</option>
                        <option value="triple">Triple</option>
                    </select>
                </div>
                <div style={styles.row}>
                    <label style={styles.label}>Fill Color:</label>
                    <input
                        type="color"
                        value={fillColor || '#ffffff'}
                        onChange={handleFillColorChange}
                        style={styles.colorInput}
                    />
                </div>
            </div>

            <div style={styles.section}>
                <h4 style={styles.sectionTitle}>Filling</h4>
                <div style={styles.row}>
                    <label style={styles.label}>Type:</label>
                    <select
                        value={fillType || 'none'}
                        onChange={handleFillTypeChange}
                        style={styles.select}
                    >
                        <option value="none">None</option>
                        <option value="solid">Solid</option>
                        <option value="parallel">Parallel</option>
                    </select>
                </div>

                {fillType === 'parallel' && (
                    <div style={styles.subSection}>
                        <div style={styles.row}>
                            <label style={styles.label}>Spacing:</label>
                            <input
                                type="number"
                                value={spacing || 0}
                                onChange={handleSpacingChange}
                                style={styles.input}
                                step="0.5"
                            />
                        </div>
                        <div style={styles.row}>
                            <label style={styles.label}>Angle:</label>
                            <input
                                type="number"
                                value={angle || 0}
                                onChange={handleAngleChange}
                                style={styles.input}
                            />
                        </div>
                        <div style={styles.row}>
                            <label style={styles.label}>Segment:</label>
                            <input
                                type="number"
                                value={segmentLength || 0}
                                onChange={handleSegmentChange}
                                style={styles.input}
                            />
                        </div>
                    </div>
                )}
            </div>

            {(selectedObject.typeName === 'CrossArea' || selectedObject.type === 'CrossArea') && (
                <div style={styles.section}>
                    <h4 style={styles.sectionTitle}>Cross Colors</h4>
                    <div style={styles.colorPalette}>
                        {selectedObject.colorPalette && selectedObject.colorPalette.map((paletteColor, index) => (
                            <div
                                key={index}
                                style={{
                                    ...styles.colorSwatch,
                                    backgroundColor: paletteColor.color,
                                    border: selectedCrossColorId === paletteColor.color_id ? '2px solid blue' : '1px solid #ccc',
                                    ...(paletteColor.NoDraw && {
                                        backgroundImage: 'repeating-linear-gradient(45deg, #ccc 0 5px, transparent 5px 10px)',
                                        backgroundSize: '10px 10px'
                                    })
                                }}
                                onClick={() => onSelectedCrossColorIdChange(paletteColor.color_id)}
                                title={paletteColor.NoDraw ? "Not Drawing" : `Color ID: ${paletteColor.color_id}`}
                            />
                        ))}
                    </div>
                    <div style={{ ...styles.row, marginTop: '15px' }}>
                        <label style={styles.label}>Columns:</label>
                        <input
                            type="number"
                            value={cols || 0}
                            onChange={(e) => onPropertyChange('cols', parseInt(e.target.value))}
                            style={styles.input}
                        />
                    </div>
                    <div style={styles.row}>
                        <label style={styles.label}>Rows:</label>
                        <input
                            type="number"
                            value={rows || 0}
                            onChange={(e) => onPropertyChange('rows', parseInt(e.target.value))}
                            style={styles.input}
                        />
                    </div>
                    <div style={styles.row}>
                        <label style={styles.label}>Cross Size:</label>
                        <input
                            type="number"
                            value={crossSize || 0}
                            onChange={(e) => onPropertyChange('crossSize', parseFloat(e.target.value))}
                            style={styles.input}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

const styles = {
    container: {
        width: '250px',
        backgroundColor: '#f8f8f8',
        borderLeft: '1px solid #ccc',
        padding: '20px',
        boxSizing: 'border-box',
        height: '100%',
        overflowY: 'auto',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
    },
    title: {
        marginTop: 0,
        marginBottom: '20px',
        fontSize: '1.2rem',
        borderBottom: '2px solid #ddd',
        paddingBottom: '10px'
    },
    section: {
        marginBottom: '25px',
        backgroundColor: '#fff',
        padding: '12px',
        borderRadius: '8px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
    },
    sectionTitle: {
        marginTop: 0,
        marginBottom: '15px',
        fontSize: '0.9rem',
        color: '#666',
        textTransform: 'uppercase',
        letterSpacing: '1px'
    },
    subSection: {
        marginTop: '15px',
        paddingTop: '15px',
        borderTop: '1px solid #eee'
    },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '12px',
        alignItems: 'center'
    },
    label: {
        fontSize: '0.85rem',
        color: '#333',
        fontWeight: '500'
    },
    input: {
        width: '70px',
        padding: '6px',
        borderRadius: '4px',
        border: '1px solid #ccc',
        fontSize: '0.85rem'
    },
    colorInput: {
        width: '40px',
        height: '30px',
        padding: '0',
        border: 'none',
        backgroundColor: 'transparent',
        cursor: 'pointer'
    },
    select: {
        width: '100px',
        padding: '6px',
        borderRadius: '4px',
        border: '1px solid #ccc',
        fontSize: '0.85rem',
        backgroundColor: '#fff'
    },
    colorPalette: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '5px',
        marginBottom: '15px'
    },
    colorSwatch: {
        width: '30px',
        height: '30px',
        borderRadius: '4px',
        cursor: 'pointer',
        boxSizing: 'border-box'
    }
};

export default RightPanel;
